import React from 'react';
import PropTypes from 'prop-types';

export default class ProfileErrors extends React.Component {
    static propTypes = {
        profileErrors: PropTypes.object.isRequired,
    };

    renderErrors() {
        const errors = this.props.profileErrors;
        const keys = Object.keys(errors);
        const last = keys.length - 1;

        return (
            <div className="u-pb16">
                Du må fylle ut{' '}
                <ul className="list list--horizontal">
                    {keys.map((key, i) => (
                        <li className="u-mr8" key={key}>
                            <a className="underline" href="#">
                                {errors[key]}
                            </a>
                            {i < last && ', '}
                        </li>
                    ))}
                </ul>{' '}
                for å kunne publisere bedriftsprofilen
            </div>
        );
    }

    render() {
        if (Object.keys(this.props.profileErrors).length) {
            return this.renderErrors();
        } else {
            return null;
        }
    }
}
